module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-300.3cff98e259e1e1b74a84f99f3f1cd96d.woff";